/**
 * @generated SignedSource<<73a56fdb02ab82b5cd47ce457da806a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type naturePivotPage_Query$variables = {
  perspectiveId?: string | null | undefined;
};
export type naturePivotPage_Query$data = {
  readonly expenseNatures: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
    readonly parent: {
      readonly id: string;
    } | null | undefined;
  }>;
  readonly natureCrossTab: {
    readonly byPnlLine: ReadonlyArray<{
      readonly cents: number;
      readonly expenseNature: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly pnlLine: string;
    }>;
    readonly byStakeholder: ReadonlyArray<{
      readonly cents: number;
      readonly expenseNature: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly stakeholder: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
    }>;
    readonly totalCents: number;
  };
};
export type naturePivotPage_Query = {
  response: naturePivotPage_Query$data;
  variables: naturePivotPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "perspectiveId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "perspectiveId",
    "variableName": "perspectiveId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": (v1/*: any*/),
  "concreteType": "ExpenseNature",
  "kind": "LinkedField",
  "name": "expenseNatures",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ExpenseNature",
      "kind": "LinkedField",
      "name": "parent",
      "plural": false,
      "selections": [
        (v2/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCents",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cents",
  "storageKey": null
},
v7 = [
  (v2/*: any*/),
  (v3/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "ExpenseNature",
  "kind": "LinkedField",
  "name": "expenseNature",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "stakeholder",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pnlLine",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "naturePivotPage_Query",
    "selections": [
      (v4/*: any*/),
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NatureCrossTab",
        "kind": "LinkedField",
        "name": "natureCrossTab",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NatureStakeholderCell",
            "kind": "LinkedField",
            "name": "byStakeholder",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NaturePnlCell",
            "kind": "LinkedField",
            "name": "byPnlLine",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v10/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "naturePivotPage_Query",
    "selections": [
      (v4/*: any*/),
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NatureCrossTab",
        "kind": "LinkedField",
        "name": "natureCrossTab",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NatureStakeholderCell",
            "kind": "LinkedField",
            "name": "byStakeholder",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NaturePnlCell",
            "kind": "LinkedField",
            "name": "byPnlLine",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v10/*: any*/),
              (v8/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "956154dbe10df28e8866e6dc527b94a7",
    "id": null,
    "metadata": {},
    "name": "naturePivotPage_Query",
    "operationKind": "query",
    "text": "query naturePivotPage_Query(\n  $perspectiveId: ID\n) {\n  expenseNatures(perspectiveId: $perspectiveId) {\n    id\n    name\n    parent {\n      id\n    }\n  }\n  natureCrossTab(perspectiveId: $perspectiveId) {\n    totalCents\n    byStakeholder {\n      cents\n      expenseNature {\n        id\n        name\n      }\n      stakeholder {\n        id\n        name\n      }\n      id\n    }\n    byPnlLine {\n      cents\n      pnlLine\n      expenseNature {\n        id\n        name\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "99ec7550bcd19ea0945493f05930934b";

export default node;
